var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnableonlinetransactions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 160,
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7419",
    "data-name": "Rectangle 7419",
    width: 380,
    height: 160,
    transform: "translate(726 260)",
    fill: "#f0e4e4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7447",
    "data-name": "Rectangle 7447",
    width: 153.204,
    height: 124.684,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33634",
    "data-name": "Path 33634",
    d: "M96.093,5.351a60.185,60.185,0,1,0,.006,0Z",
    transform: "translate(-35.91 -5.351)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enable_online_transactions",
    "data-name": "Enable online transactions",
    transform: "translate(-726 -260)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30042",
    "data-name": "Group 30042",
    transform: "translate(839.793 277.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30037",
    "data-name": "Group 30037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30036",
    "data-name": "Group 30036",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33609",
    "data-name": "Path 33609",
    d: "M141.563,94.736l5.6.6,14.067,1.5,18.149,1.938-5.857-9.467-.11.069-.019-.03.11-.069,20.641-12.707L225.1,57.437l-.023-.044a25.275,25.275,0,0,0-34.785-8.213l-30.1,18.6.022.036-.094.057-.021-.036.093-.056-5.384-8.691-5.826,15.676-5.458,14.693Z",
    transform: "translate(-75.576 -24.239)",
    fill: "#121b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33610",
    "data-name": "Path 33610",
    d: "M168.339,76.236l.1-.06.023.037-.1.06Z",
    transform: "translate(-89.87 -40.668)",
    fill: "#121b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33611",
    "data-name": "Path 33611",
    d: "M198.311,124.724l.115-.072-.021-.032-.115.072Z",
    transform: "translate(-105.86 -66.53)",
    fill: "#121b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33612",
    "data-name": "Path 33612",
    d: "M91.434,111.173l-5.6-.6-14.067-1.5-18.149-1.938L59.48,116.6l.11-.069.019.03-.11.069L38.86,129.341,7.9,148.472l.024.044A25.275,25.275,0,0,0,42.71,156.73l30.1-18.6-.021-.036.093-.057.022.036-.094.056,5.38,8.689,5.826-15.676,5.458-14.693Z",
    transform: "translate(-4.218 -57.197)",
    fill: "#121b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33613",
    "data-name": "Path 33613",
    d: "M146.23,178.667l.1-.06.023.037-.1.06Z",
    transform: "translate(-78.067 -95.352)",
    fill: "#121b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33614",
    "data-name": "Path 33614",
    d: "M116.363,130.15l-.115.072.021.032.115-.072Z",
    transform: "translate(-62.061 -69.483)",
    fill: "#121b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33615",
    "data-name": "Path 33615",
    d: "M96.069,5.275A60.215,60.215,0,1,1,35.852,65.488,60.215,60.215,0,0,1,96.069,5.275Z",
    transform: "translate(-19.14 -2.816)",
    fill: "#f6f8ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30039",
    "data-name": "Group 30039",
    transform: "translate(16.739 2.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30038",
    "data-name": "Group 30038",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33616",
    "data-name": "Path 33616",
    d: "M61.562,141.126H36.24a63.894,63.894,0,0,0,6.28,24.51H64.2a137.046,137.046,0,0,1-2.632-24.51",
    transform: "translate(-36.086 -77.837)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33617",
    "data-name": "Path 33617",
    d: "M57.983,208.484a60.884,60.884,0,0,0,27.5,23.09,140.491,140.491,0,0,1-8.111-23.09Z",
    transform: "translate(-47.694 -113.797)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33618",
    "data-name": "Path 33618",
    d: "M115.647,27.5h19.767V0a58.7,58.7,0,0,0-9.084,1.232A133.867,133.867,0,0,0,115.645,27.5",
    transform: "translate(-78.478 -2.494)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33619",
    "data-name": "Path 33619",
    d: "M86.687,8.414a60.824,60.824,0,0,0-28.7,23.58H77.939a140.443,140.443,0,0,1,8.749-23.58",
    transform: "translate(-47.697 -6.986)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33620",
    "data-name": "Path 33620",
    d: "M172.307,27.5h19.767A133.4,133.4,0,0,0,181.39,1.232,58.457,58.457,0,0,0,172.307,0Z",
    transform: "translate(-108.728 -2.494)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33621",
    "data-name": "Path 33621",
    d: "M115.646,208.484a133.837,133.837,0,0,0,10.685,26.27,58.706,58.706,0,0,0,9.084,1.232v-27.5H115.648",
    transform: "translate(-78.478 -113.797)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33622",
    "data-name": "Path 33622",
    d: "M172.307,235.986a58.454,58.454,0,0,0,9.083-1.232,133.391,133.391,0,0,0,10.684-26.27H172.307Z",
    transform: "translate(-108.728 -113.797)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33623",
    "data-name": "Path 33623",
    d: "M239.519,31.994a60.8,60.8,0,0,0-28.694-23.58,139.883,139.883,0,0,1,8.749,23.58Z",
    transform: "translate(-129.291 -6.986)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33624",
    "data-name": "Path 33624",
    d: "M64.642,73.775H42.5a63.941,63.941,0,0,0-6.284,24.51H61.581a137.673,137.673,0,0,1,3.061-24.51",
    transform: "translate(-36.074 -41.88)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33625",
    "data-name": "Path 33625",
    d: "M104.942,98.287H129.7V73.777H108.161a130.288,130.288,0,0,0-3.216,24.51",
    transform: "translate(-72.764 -41.881)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33626",
    "data-name": "Path 33626",
    d: "M193.846,73.775H172.307v24.51h24.758a129.593,129.593,0,0,0-3.22-24.51",
    transform: "translate(-108.728 -41.88)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33627",
    "data-name": "Path 33627",
    d: "M107.649,165.638h22.014v-24.51h-24.8a129.972,129.972,0,0,0,2.785,24.51",
    transform: "translate(-72.723 -77.838)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33628",
    "data-name": "Path 33628",
    d: "M208.816,193.07l.713-.54v.54Z",
    transform: "translate(-128.218 -105.279)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33629",
    "data-name": "Path 33629",
    d: "M192.7,141.094v15.336l-12.223,9.177h-8.148V141.088Z",
    transform: "translate(-108.741 -77.816)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33630",
    "data-name": "Path 33630",
    d: "M233.17,73.775a136.889,136.889,0,0,1,3.061,24.51H261.6a63.785,63.785,0,0,0-6.281-24.51Z",
    transform: "translate(-141.22 -41.88)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33631",
    "data-name": "Path 33631",
    d: "M236.752,141.126h25.322a63.92,63.92,0,0,1-6.281,24.51h-21.68a137.052,137.052,0,0,0,2.639-24.51",
    transform: "translate(-141.724 -77.837)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33632",
    "data-name": "Path 33632",
    d: "M194.269,165.638H172.254v-24.51h24.8a130.008,130.008,0,0,1-2.785,24.51",
    transform: "translate(-108.699 -77.838)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33633",
    "data-name": "Path 33633",
    d: "M239.609,208.484a60.884,60.884,0,0,1-27.5,23.09,140.494,140.494,0,0,0,8.111-23.09Z",
    transform: "translate(-129.975 -113.797)",
    fill: "#94c1ea"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30041",
    "data-name": "Group 30041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30040",
    "data-name": "Group 30040",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33635",
    "data-name": "Path 33635",
    d: "M74.934,67.636,72.92,72.89,67.848,86.1l-6.541,17.04-5.76-9.527.111-.067-.018-.03-.111.066L34.815,106.167,3.683,125.017l-.027-.041a25.275,25.275,0,0,1,8.531-34.709L42.45,71.941l.022.035.093-.058-.022-.035-.093.058L37.167,63.19l16.609,1.953,15.566,1.833Z",
    transform: "translate(0 -33.735)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33636",
    "data-name": "Path 33636",
    d: "M87.5,82.433l-.1.061-.023-.037.1-.061Z",
    transform: "translate(-46.648 -43.988)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33637",
    "data-name": "Path 33637",
    d: "M116.982,131.169l-.117.07-.019-.033.117-.07Z",
    transform: "translate(-62.381 -70.009)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33638",
    "data-name": "Path 33638",
    d: "M87.5,82.433l-.1.061-.023-.037.1-.061Z",
    transform: "translate(-46.648 -43.988)",
    fill: "#2352c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33639",
    "data-name": "Path 33639",
    d: "M167.911,128.582l2.014-5.254L175,110.122l6.541-17.04,5.759,9.527-.11.067.017.03.111-.066L208.03,90.051,239.163,71.2l.026.041a25.274,25.274,0,0,1-8.531,34.709l-30.265,18.327-.022-.035-.094.058.023.035.093-.058,5.285,8.751-16.61-1.953L173.5,129.242Z",
    transform: "translate(-89.642 -38.012)",
    fill: "#fa9419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33640",
    "data-name": "Path 33640",
    d: "M241.031,184.116l.1-.061.023.037-.1.061Z",
    transform: "translate(-128.678 -98.261)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33641",
    "data-name": "Path 33641",
    d: "M211.531,135.375l.117-.07.019.033-.117.07Z",
    transform: "translate(-112.929 -72.235)",
    fill: "#4972f4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableonlinetransactions);
export default __webpack_public_path__ + "static/media/enableonlinetransactions.e695d7af517fb9ad3d6849928c539071.svg";
export { ForwardRef as ReactComponent };